export default __webpack_public_path__ + "static/media/evenshot.79410971.png";